import sample from "lodash/sample";

export const randomBetweenExcluding_highMemoryUsage = (
  min: number,
  max: number,
  exclude: number
): number => {
  const range = Array.from({ length: Math.abs(max - min) + 1 }, (_, index) => {
    const value = Math.min(min, max) + index;
    if (value === exclude) {
      return null;
    } else return value;
  }).filter((value) => value != null);

  if (range.length === 0) {
    throw new Error("No valid numbers in range after exclusion");
  }

  return sample(range)!;
};
